import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {BillingService} from '../../service/billing/billingService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class SalesRepGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		this.local = false;
		
		var salesRepGrid = this;
		setTimeout(function(){
			salesRepGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var salesRepGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},				
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_SALES_REPS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function() {							
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_SALES_REPS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')
					],
					listeners: {
						click: function() {							
							actionAddEdit(grid.selectedItems[0]);
						}
					}
				},							
				{
					tag: 'dl-action-button',
					itemid: 'delete',
					theme: 'error primary',					
					permissions: ['ADMIN_BILLING_SALES_REPS:DELETE'],
					'class': 'spacer-toolbar-item',
					style: 'float: right;',					
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							actionDelete(grid.selectedItems[0]);
						}
					}
				}			
			]
		});	
		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}				
			},			
			children: [	
				{						
					path: 'repFirstName',
					header: 'First Name',					
					width: '7em'
				},
				{						
					path: 'repLastName',
					header: 'Last Name',					
					width: '7em'
				},				
				{						
					path: 'repEmail',
					header: 'Email',					
					'flex-grow': '1'					
				},
				{						
					path: 'repPhone',
					header: 'Phone',						
					width: '9em'
				},
				{						
					path: 'repCellPhone',
					header: 'Cell Phone',					
					width: '9em'
				},
				{						
					path: 'insideRepFlg',
					header: 'Inside Sale Rep',					
					'text-align': 'center',
					width: '9em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {						
						ElementUtil.query(toolbar, 'edit').disabled = false; 
						ElementUtil.query(toolbar, 'delete').disabled = false;
					} else {						
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}	
				}
			}
		});		
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 200,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
					
					salesRepGrid.currentFilter = {
						offset: pageRange.offset,
						max: pageRange.max,
						sortField: backingGrid.currentSortField,
						sortOrder: backingGrid.currentSortDirection					
					};
					
					var successHandler = function(records) {
						loadMask.remove();
						grid.activeItem = null;						
						grid.items = records.data;
						
						salesRepGrid.fullDataSet = records.data;						
						pagingToolbar.totalRecords = records.totalNumber;
						pagingToolbar.updatePager();						
					};
					
					BillingService.getSalesRepService().getSaleReps(salesRepGrid.currentFilter)
					.then(function(records){							
						successHandler(records);
					});
										
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();
				}
			}
			
		});		
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'sales-reps',
			onDetail: function() {
				ExportUtil.exportGridItemsAsCsv(grid.items, 'sales-reps.csv');
			}
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		salesRepGrid.append(flexLayout);		
		
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);			
		};
		
		var actionAddEdit = function(record) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Add/Edit Sale Rep',
				icon: 'lumo:edit',
				listeners: {
					ready: function() {						
						addEditWin.show();
								
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-combo-box',											
											label: 'Reference Company', 
											name: 'refCompanyId',
											'item-value-path': 'refCompanyId',
											'item-label-path': 'companyName',
											required: true,
											postinit: function(combo) {
												BillingService.getReferenceCompanyService().getReferenceCompanies().then(function(data){
													combo.items = data.data;
												});
											}	
										},
										{										
											tag: 'vaadin-checkbox',									
											name: 'insideRepFlg',
											label: 'Inside Sales Rep'										
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'vaadin-text-field',
											label: 'First Name',
											name: 'repFirstName',
											required: true,
											maxlength: 80
										},	
										{
											tag: 'vaadin-text-field',
											label: 'Last Name',
											name: 'repLastName',											
											required: true,
											maxlength: 80
										},
										{
											tag: 'vaadin-text-field',
											label: 'Phone',
											name: 'repPhone',											
											maxlength: 16
										},
										{
											tag: 'vaadin-text-field',
											label: 'Cell Phone',
											name: 'repCellPhone',											
											maxlength: 16
										},										
										{
											tag: 'vaadin-text-field',
											label: 'Fax',
											name: 'repFax',												
											maxlength: 16
										},										
										{
											tag: 'vaadin-text-field',
											label: 'Email',
											name: 'repEmail',											
											maxlength: 255
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'vaadin-text-field',
											label: 'Address Line 1',
											name: 'addressLine1',											
											maxlength: 80
										},
										{
											tag: 'vaadin-text-field',
											label: 'Address Line 2',
											name: 'addressLine2',											
											maxlength: 80
										},
										{
											tag: 'vaadin-text-field',
											label: 'City',
											name: 'cityName',										
											maxlength: 80
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'state',
											label: 'State/Providence', 
											name: 'stateProvCode',
											'item-value-path': 'code',
											'item-label-path': 'description',
											postinit: function(combo) {
												Service.getLookupService().getLookupValues('StateProvCode').then(function(data){
													combo.items = data;
												});
											}
										},
										{
											tag: 'vaadin-text-field',
											label: 'Postal Code',
											name: 'postalCode',											
											maxlength: 80
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																
															formPanel.submitForm({
																preSubmit: function(data) {
																	var stateCB = ElementUtil.query(formPanel, 'state');																	
																	if (stateCB.selectedItem) {
																		data.countryCode = stateCB.selectedItem.country;
																	} else {
																		delete data.stateProvCode;
																	}
																	if (!data.insideRepFlg) {
																		data.insideRepFlg = false;
																	}
																	if (record) {
																		data.salesRepId = record.salesRepId;
																	}
																	return data;
																},
																actualCall: function(data) {
																	return BillingService.getSalesRepService().saveSaleRep(data, record ? true : false);
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Sales Rep', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	if (formPanel.successCallback) {
																		formPanel.successCallback();
																	}
																	actionRefresh();
																	addEditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						addEditWin.addToContentElement(formPanel);	
						
						if (record) {
							formPanel.load(record);							
						}
						
					}
				}
			});
		
						
		};
		
		var actionDelete = function(record) {
			var summary = window.DL.MessageUtil.ellipseText(record.repFirstName, 20);
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete ' + summary + ' sales rep?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Deleting...');													
							
							BillingService.getSalesRepService().deleteSaleRep(record.salesRepId).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Deleted: ' + summary, {									
									theme: 'success'
								});
								actionRefresh();
							});															
							
						}	
					},
					{
						text: 'No'
					}
				]
			});				
		};		

	}
	
};
customElements.define('dl-salesrep-grid', SalesRepGrid);


